module.exports = __webpack_public_path__ + "static/media/only-me.d3a5a66b.svg";